import { render } from "./roleModules.vue?vue&type=template&id=0ea98727&ts=true"
import script from "./roleModules.vue?vue&type=script&lang=ts"
export * from "./roleModules.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__